import { registerPlugin } from '@capacitor/core';
const ChottuLinkIonicSDK = registerPlugin('ChottuLinkIonicSDK', {
    web: () => import('./web').then((m) => new m.ChottuLinkIonicSDKWeb()),
});
export * from './definitions';
export { ChottuLinkIonicSDK };
//# sourceMappingURL=index.js.map